import React, { FC, useEffect, useRef, useState } from 'react'
import { tawreedTranslationService } from '../../../../../common/translations';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { OrderDto } from '../../domain';
import { TawreedAction, TawreedActionName } from '../../../../../common/actions';
import { BulkResponse, OrderStatus } from '../../data';
import { PrimeIcons } from 'primereact/api';
import { AuthUtils } from '../../../../auth/domain';
import * as actions from "./order-form/actions";
import { RadioButton } from 'primereact/radiobutton';
import { TawreedFormField, TawreedInputText } from '../../../../../common';
import { DeliveryDropdownComponent } from './order-form/actions/confirm/delivery-dropdown.component';
import { toastService } from '../../../../notifications/domain';
import { OrderDetailsTemplate } from './bulk-actions-order-details-template';
import { Card } from 'primereact/card';
import { Tag } from 'primereact/tag';
import { DateUtils } from '../../../../../helpers/date';
import { ObjectUtils } from '../../../../../helpers/object';
import { GlobalContext } from '../../../../../context';

export interface BulkActionDialogProps {
    visible: boolean;
    status?: number;
    orders: OrderDto[],
    hide: () => void;
    onDetails: (orderId: number) => void;
    onRemove: (orderId: number) => void;
}
export type orderConfirmState = {
    /**
     *
     */
    carrier: number | undefined;
    orderId: number | undefined;
}
export const BulkActionDialog: FC<BulkActionDialogProps> = ({ visible, hide, orders, status,onDetails, onRemove }) => {

    const [bulkActions, setBulkActions] = React.useState<TawreedAction[]>([]);
    const [bulkActionsResult, setBulkActionResult] = React.useState<BulkResponse[]>([]);
    const [selectedAction, setSelectedAction] = React.useState("");
    const [orderConfirmState, setOrderConfirmState] = React.useState<orderConfirmState[]>([]);
    const [actionButtonState, setActionButtonState] = useState<{
        disabled: boolean,
        title: string,
    }>({
        disabled: true,
        title: 'msg_def_prompt_accept_label'
    });
    const {auth: { user }, constants: { constants } } = React.useContext(GlobalContext);
    const [orderList, setOrderList] = useState<OrderDto[]>(orders);

    useEffect(()=>{
        if (visible) {
            if (status) {
                var available_actions: TawreedAction[] = [];
                switch (status) {
                    case OrderStatus.Placed:
                        available_actions = [
                            new TawreedAction(TawreedActionName.OrdersReview, 'statefull', 'lbl_sales_orders_review', PrimeIcons.FILE, onExecuteAction, undefined, 'confirm'),
                            new TawreedAction(TawreedActionName.OrdersConfirm, 'statefull', 'lbl_sales_orders_confirm', PrimeIcons.CHECK, onExecuteAction, undefined, 'confirm'),
                        ];
                        break;
                    case OrderStatus.UNDER_REVIEWED:
                        available_actions = [
                            new TawreedAction(TawreedActionName.OrdersConfirm, 'statefull', 'lbl_sales_orders_confirm', PrimeIcons.CHECK, onExecuteAction, undefined, 'confirm'),
                        ];
                        break;
                    case OrderStatus.Processing:
                        break;
                }
                available_actions = available_actions.filter(e => AuthUtils.current().authorized(e.name));
                setBulkActions(available_actions);
            }
        }
        else {
            setBulkActionResult([]);
            setSelectedAction("");
            setOrderConfirmState([]);
            setActionButtonState({...actionButtonState, disabled:true});
        }
    },[visible]);

    useEffect(() => {

        if (bulkActionsResult.length > 0) {
            setBulkActions([]);
            if (bulkActionsResult.filter(x => !x.success).length > 0) {
                setActionButtonState({ title: "msg_def_prompt_retry", disabled: false });
            }
            else {
                setActionButtonState({ ...actionButtonState, disabled: true });
            }
        }
        else{
            setActionButtonState({ ...actionButtonState, title: "msg_def_prompt_accept_label" });
        }
    }, [bulkActionsResult]);

    useEffect(()=>{
        setOrderList([...orders]);
    },[orders]);

    useEffect(()=>{
        switch (selectedAction) {
            case TawreedActionName.OrdersReview.toString():
                setOrderConfirmState([]);
                setActionButtonState({...actionButtonState, disabled:false});
                break;
            case TawreedActionName.OrdersConfirm.toString():
                setOrderConfirmState(orderList.map(order=>{ 
                    return {
                        orderId: order.orderId,
                        carrier: undefined
                    }}));
                    setActionButtonState({...actionButtonState, disabled:false});
                break;
            default:
                break;
        }
    },[selectedAction]);

    const onExecuteAction = (): Promise<void> => {
        return new Promise((resolve) => {
            var orderIds: number[] = [];
            if (bulkActionsResult.length > 0) {
                orderIds = bulkActionsResult.filter(x => !x.success).map(x => x.orderId);
            }
            else {
                orderIds = orderList.map(x => x.orderId!);
            }
            if (orderIds.length > 0) {
                switch (selectedAction) {
                    case TawreedActionName.OrdersReview.toString():
                        onReview(orderIds);
                        break;
                    case TawreedActionName.OrdersConfirm.toString():
                        onConfirm(orderIds);
                        break;
                    default:
                        break;
                }
            }
            resolve();
        });
    }

    const onReview = (orderIds: number[]): Promise<void> => {
        setActionButtonState({...actionButtonState, disabled:true});
        return actions
            .onReviewAll(orderIds)
            .then(res => {
                setActionButtonState({...actionButtonState, disabled:false});
                if (res) {
                    setBulkActionResult(res);
                }
            });
    }
    
    const onConfirm = (orderIds: number[]): Promise<void> => {
        return new Promise((resolve)=>{
            if(orderConfirmState.length>0 && orderConfirmState.filter(x=>!x.carrier).length===0){
                setActionButtonState({...actionButtonState, disabled:true});
                return actions
                    .onConfirmAll(orderConfirmState.filter(x=> orderIds.includes(x.orderId!)).map(order=>{
                        return {
                            carrierId: order.carrier!,
                            orderId: order.orderId!
                        }
                    }))
                    .then(res => {
                        setActionButtonState({...actionButtonState, disabled:false});
                        if (res) {
                            setBulkActionResult(res);
                        }
                    });
                }
                else{
                     toastService.show({ detail: tawreedTranslationService.translate('lbl_sales_orders_store_delivery_selected'), severity: 'error' });
                }
        })
        
    }

    const onCarrierSelect = (value: number, orderId: number): void => {
        var index = orderConfirmState.findIndex(x=>x.orderId === orderId);
        console.log("index",index);
        if(index>=0){
            var newOrderConfirmState = [...orderConfirmState];
            newOrderConfirmState.splice(index,1);
            newOrderConfirmState.push({orderId: orderId,carrier:value});
            console.log("index",newOrderConfirmState);
            setOrderConfirmState([...newOrderConfirmState])
        }
        else{
            setOrderConfirmState([...orderConfirmState, {orderId: orderId,carrier:value}])
        }
    }

    const deleteOrder = ( orderId: number): void =>{
        var newOrderList = orderList.filter(x=>x.orderId !== orderId);
        setOrderList(newOrderList);
        onRemove(orderId)
        if(newOrderList.length === 0){
            hide();
        }
        if(orderConfirmState.length>0){
            var newOrderConfirmState = orderConfirmState.filter(x=>x.orderId !== orderId);
            
            setOrderConfirmState(newOrderConfirmState);
        }
    }


  

    const ImportProductsDialogFooter = () => {
        return (<div>
            <Button label={tawreedTranslationService.translate('lbl_cancel')} icon="pi pi-times" onClick={hide} className="p-button-text" disabled={false} />
            <Button label={tawreedTranslationService.translate(actionButtonState.title)} icon="pi pi-check"
             className="p-button-text" onClick={()=>{
                onExecuteAction().then(()=>{
                    // hide();
                })
             }} disabled={actionButtonState.disabled} />
        </div>);
    }

    return (
        <Dialog style={{ minWidth: '50%' }} header={tawreedTranslationService.translate('lbl_bulk_action')}
         visible={visible} footer={<ImportProductsDialogFooter />} onHide={hide} draggable={false}
          position="top" closable={true} closeOnEscape={true} maximizable={true}>
             <div className="flex flex-wrap gap-3">
                            {
                                bulkActions.map((e, index) =>
                                    <div className="flex align-items-center">
                                    <RadioButton key={index}
                                            name={"actions"}
                                            inputId={e.name.toString()}
                                            value={e.name.toString()}
                                            onChange={()=>{setSelectedAction(e.name.toString())}}
                                            checked={selectedAction === e.name.toString()}
                                        className={e.className}
                                         />
                                         <label htmlFor="ingredient1" className="ml-2">
                                            {
                                                tawreedTranslationService.translate(typeof(e.title) === 'string' ? e.title : '')
                                            }
                                         </label>
                                         </div>)
                            }
                        </div>
            <ul className='p-confirm-dialog-message'>
                {
                    orderList.map(order => 
                        {
                        return <Card key={order.orderId} className='card' header={
                         <div className='grid'>
                            <div className='col-7'>
                            <div className="flex">
                                 <h4 className='mr-auto'>
                                    {order.customer?.partnerName}
                                </h4>
                            </div>
                            </div>
                            <div className='col-4'>
                                <h4 className='mr-auto'>
                                    {ObjectUtils.toFixed(order.orderTotal, user?.scale!)} {( AuthUtils.current().language === "en"? "J.D": "د.أ")}
                                </h4>
                            </div>
                                <Button icon="pi pi-times" onClick={() => deleteOrder(order.orderId!)} className="p-button-success p-button-rounded ml-auto" disabled={false} />
                         </div>
                        } footer={
                            <div className='flex'>
                              <Button onClick={() => onDetails(order.orderId!)} label={tawreedTranslationService.translate('lbl_finance_header')} className="p-button-success ml-auto" />
                                
                            </div>
                        }>
                                
                            <OrderDetailsTemplate rowData={order} key={order.orderId} 
                                response={bulkActionsResult.find(x => x.orderId === order.orderId)}></OrderDetailsTemplate>
                            {
                                selectedAction === TawreedActionName.OrdersConfirm.toString() &&
                                <div className='grid'>
                                    <TawreedFormField key={"carrier"+order.orderId} name={"carrier"+order.orderId} 
                                    title="lbl_sales_orders_carrier" className="field col-6">
                                        <DeliveryDropdownComponent
                                            salesOrderId={order.orderId!}
                                            dropdownValue={orderConfirmState.find(x=>x.orderId === order.orderId)?.carrier}
                                            dropdownName={"carrier" + order.orderId}
                                            dropdownOptionLabel={AuthUtils.current().language === "en" ? "titleEn" : "titleAr"}
                                            dropdownOptionValue="partnerId"
                                            dropDownPreSelected={value => onCarrierSelect(value, order.orderId!)}
                                            dropdownOnChange={e => onCarrierSelect(e.value, order.orderId!)}
                                            dropdownRender="standalone" />
                                    </TawreedFormField>
                                </div>
                            }
                        </Card>
                    })
                }
            </ul>
        </Dialog>
    )
}